const CustomSectionsType = {
  SET_CUSTOM_SECTION_LIST: 'SET_CUSTOM_SECTION_LIST',
  SET_CUSTOM_SECTION_COLUMNS_LIST: 'SET_CUSTOM_SECTION_COLUMNS_LIST',
  SET_EDIT_COLUMN_DATA: 'SET_EDIT_COLUMN_DATA',
  SET_CUSTOM_SECTION_DYNAMIC_COLUMNS: 'SET_CUSTOM_SECTION_DYNAMIC_COLUMNS',
  SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS: 'SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS',
  SET_ALL_CUSTOM_SAMPLES_TRACKING: 'SET_ALL_CUSTOM_SAMPLES_TRACKING',
  SET_SECTIONS_WITH_COLUMNS: 'SET_SECTIONS_WITH_COLUMNS',
  UNMOUNT_CUSTOM_MODAL: 'UNMOUNT_CUSTOM_MODAL',
  CUSTOM_SECTION_BOM_ALL_TYPES: 'CUSTOM_SECTION_BOM_ALL_TYPES',

  // Range Plan Specific Action Types
  SET_RANGEPLAN_CUSTOM_SECTIONS: 'SET_RANGEPLAN_CUSTOM_SECTIONS',
  ADD_RANGEPLAN_CUSTOM_SECTION: 'ADD_RANGEPLAN_CUSTOM_SECTION',
  UPDATE_RANGEPLAN_CUSTOM_SECTION: 'UPDATE_RANGEPLAN_CUSTOM_SECTION',
  DELETE_RANGEPLAN_CUSTOM_SECTION: 'DELETE_RANGEPLAN_CUSTOM_SECTION',
  TOGGLE_SECTION_EDITING: 'TOGGLE_SECTION_EDITING',
  SET_SECTION_EDITING_STATE: 'SET_SECTION_EDITING_STATE',
  CLEAR_CUSTOM_SECTIONS_DATA: 'CLEAR_CUSTOM_SECTIONS_DATA',

  // Section-wise columns management
  SET_SECTION_WISE_COLUMNS: 'SET_SECTION_WISE_COLUMNS',

  SET_GRADING_GROUP_LIST: 'SET_GRADING_GROUP_LIST',
};

export default CustomSectionsType;
